import { render, staticRenderFns } from "./RPKeyword.vue?vue&type=template&id=04d7c770"
import script from "./RPKeyword.vue?vue&type=script&lang=js"
export * from "./RPKeyword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports